import { render, staticRenderFns } from "./review-list-summary.vue?vue&type=template&id=86f20642&"
import script from "./review-list-summary.vue?vue&type=script&lang=js&"
export * from "./review-list-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports